













import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'big-button',
  props: {
    text: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(_props, { emit }) {
    return {
      onClick() {
        emit('click');
      }
    };
  }
});
